export default "__VITE_ASSET__IaTt2rbo__"